


import homePayload from "./HomePayload";
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import moment from 'moment';

export async function IncidentAnalysis(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETINCIDENTANALYSIS, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentAnalysis(resp);
                return { data: formattedData.Data ? formattedData.Data : [], loader: false, total: formattedData.total };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareIncidentAnalysis = (resp) => {
    let Data = [];
    let dataObj = {};
    let buckets = [];
    let total = 0;
    if (resp) {
        buckets = resp.aggregations["Incident Status"].buckets;
        for (let i = 0; i < buckets.length; i++) {
            total = total + (buckets[i]["Number of Incidents"].value);
            dataObj = {
                group: buckets[i].key,
                value: buckets[i]["Number of Incidents"].value
            }
            Data.push(dataObj);
        }
    }
    return { Data, total };
}

export async function IncidentSummary(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETINCIDENTSUMMARY, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentSummary(resp);
                return { data: formattedData ? formattedData : [], loader: false, total: formattedData.total };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareIncidentSummary = (resp) => {
    let Data = [];
    let dataObj = {};
    let buckets = [];
    if (resp) {
        buckets = resp.aggregations.Priority.buckets;
        for (let i = 0; i < buckets.length; i++) {
            let statusBucket = buckets[i]["Incident Status"].buckets;
            for (let j = 0; j < statusBucket.length; j++) {
                dataObj = {
                    group: statusBucket[j].key,
                    key: buckets[i].key,
                    value: statusBucket[j].count.value
                }
                Data.push(dataObj);
            }
        }
    }
    return Data;
}

export async function IncidentResponseResolution(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETSLATREND, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentResponseResolution(resp);
                return { data: formattedData ? formattedData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareIncidentResponseResolution = (resp) => {
    let Data = [];
    let responseObj = {}, resolutionObj = {};;
    let buckets = [];
    if (resp) {
        buckets = resp.aggregations[2].buckets;
        for (let i = 0; i < buckets.length; i++) {
            responseObj = {
                group: "Response",
                date: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                value: buckets[i].response_per && buckets[i].response_per.value ? buckets[i].response_per.value.toFixed(2) : 0
            };
            resolutionObj = {
                group: "Resolution",
                date: buckets[i].key_as_string ? moment(new Date(buckets[i].key_as_string)).format("YYYY-MM-DD") : '',
                value: buckets[i].resolution_per && buckets[i].resolution_per.value ? buckets[i].resolution_per.value.toFixed(2) : 0
            }
            Data.push(responseObj);
            Data.push(resolutionObj);
        }
    }
    return Data;
}

export async function ReopenCountSLA(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETREOPENCOUNTSLA, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareReopenCountSLAData(resp);
                return { data: formattedData.graphData ? formattedData.graphData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareReopenCountSLAData = (response) => {
    let graphData = [];
    let tableData = [];
    let tableObj = {};
    let graphObj = {};
    let expandedItemObj = {};
    let expandedTable = [];
    let summaryData = {
        reOpenCount: 0,
        percentage: 0
    };
    let downloadableData = [];
    let downloadableObj = {};
    let reOpenCount = 0, total = 0, percentage = 0;
    if (response) {
        let buckets = response.aggregations["2"].buckets;
        for (let i = 0; i < buckets.length; i++) {
            expandedTable = [];
            total = 0;
            reOpenCount = 0;
            percentage = 0;
            tableObj = {
                id: i + 1,
                item: buckets[i].key
            };
            for (let j = 0; j < buckets[i]["5"].buckets.length; j++) {
                total = total + buckets[i]["5"].buckets[j].doc_count;
                reOpenCount = reOpenCount + buckets[i]["5"].buckets[j]["re-open-count"].value;
                graphObj = {
                    group: buckets[i]["5"].buckets[j].key,
                    key: buckets[i].key,
                    value: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) * 100) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                };
                expandedItemObj = {
                    id: j + 1,
                    item: buckets[i]["5"].buckets[j].key,
                    total: buckets[i]["5"].buckets[j].doc_count,
                    reOpenCount: buckets[i]["5"].buckets[j]["re-open-count"].value,
                    percentage: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) * 100) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                };
                downloadableObj = {
                    priority: buckets[i]["5"].buckets[j].key,
                    item: buckets[i].key,
                    total: buckets[i]["5"].buckets[j].doc_count,
                    reOpenCount: buckets[i]["5"].buckets[j]["re-open-count"].value,
                    percentage: (((buckets[i]["5"].buckets[j].doc_count - buckets[i]["5"].buckets[j]["re-open-count"].value) * 100) / buckets[i]["5"].buckets[j].doc_count).toFixed(2)
                }
                expandedTable.push(expandedItemObj);
                graphData.push(graphObj);
                downloadableData.push(downloadableObj);
            }
            tableObj.total = total;
            tableObj.reOpenCount = reOpenCount;
            tableObj.percentage = isNaN((((total - reOpenCount) * 100) / total).toFixed(2)) ? 0 : (((total - reOpenCount) * 100) / total).toFixed(2);
            tableObj.expandedItems = expandedTable;
            tableData.push(tableObj);
            summaryData.reOpenCount = summaryData.reOpenCount + tableObj.reOpenCount;
            summaryData.percentage = parseInt(summaryData.percentage) + parseInt(tableObj.percentage);
        }
        summaryData.reOpenCount = summaryData.reOpenCount;
        summaryData.percentage = summaryData.percentage / buckets.length;
    }
    return { tableData, graphData, summaryData, downloadableData };
};

export async function IncidentAgeing(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace) {

    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace);
        let formattedData = [];
        return callPostApi(Constants.GETINCIDENTAGING, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareIncidentAgeingData(resp);
                return { data: formattedData.graphData ? formattedData.graphData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareIncidentAgeingData = (response) => {
    let graphData = [];
    let tableData = [];
    let tableObj = {};
    let graphObj = {};
    let expandedItemObj = {};
    let expandedTable = [];
    let summaryData = 0, total = 0, days = 0;
    let downloadableData = [];
    let downloadableObj = {};
    if (response) {
        let buckets = response.aggregations["2"].buckets;
        for (let i = 0; i < buckets.length; i++) {
            expandedTable = [];
            total = 0;
            days = 0;
            tableObj = {
                id: i + 1,
                item: buckets[i].key
            }
            for (let j = 0; j < buckets[i]["3"].buckets.length; j++) {
                total = total + buckets[i]["3"].buckets[j].doc_count;
                days = days + Math.round(buckets[i]["3"].buckets[j]["1"].value)
                expandedItemObj = {
                    id: j + 1,
                    item: buckets[i]["3"].buckets[j].key,
                    total: buckets[i]["3"].buckets[j].doc_count,
                    days: Math.round(buckets[i]["3"].buckets[j]["1"].value)
                };
                graphObj = {
                    group: buckets[i]["3"].buckets[j].key,
                    key: buckets[i].key,
                    value: buckets[i]["3"].buckets[j]["1"].value,
                };
                downloadableObj = {
                    priority: buckets[i]["3"].buckets[j].key,
                    item: buckets[i].key,
                    days: buckets[i]["3"].buckets[j]["1"].value,
                    total: buckets[i]["3"].buckets[j].doc_count,
                }
                graphData.push(graphObj);
                expandedTable.push(expandedItemObj);
                downloadableData.push(downloadableObj);
            }
            tableObj.total = total;
            tableObj.days = isNaN(days / expandedTable.length) ? 0 : (days / expandedTable.length).toFixed(2);
            tableObj.expandedItems = expandedTable;
            tableData.push(tableObj);
            summaryData = summaryData + parseFloat(tableObj.days);
        }
        summaryData = isNaN(summaryData / buckets.length) ? 0 : (summaryData / buckets.length);
    }
    return { tableData, graphData, summaryData, downloadableData };
};

